import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureReferralFromUrl } from "@/lib/referral";

/** Mounted once in App — captures ?ref= on every navigation. */
export const ReferralCapture = () => {
  const { search } = useLocation();
  useEffect(() => {
    captureReferralFromUrl();
  }, [search]);
  return null;
};
